import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from 'swiper/modules';
import { useTranslation, Trans } from 'react-i18next';

import "swiper/css";
import "swiper/css/pagination";

import place1 from "../../../assets/assets-maldives/places/1.webp";
import place2 from "../../../assets/assets-maldives/places/2.webp";
import place3 from "../../../assets/assets-maldives/places/3.webp";
import place4 from "../../../assets/assets-maldives/places/4.webp";
import place5 from "../../../assets/assets-maldives/places/5.webp";
import place6 from "../../../assets/assets-maldives/places/6.webp";
import place7 from "../../../assets/assets-maldives/places/7.webp";
import place8 from "../../../assets/assets-maldives/places/8.webp";
import place9 from "../../../assets/assets-maldives/places/9.webp";
import place10 from "../../../assets/assets-maldives/places/10.webp";
import place11 from "../../../assets/assets-maldives/places/11.webp";
import place12 from "../../../assets/assets-maldives/places/12.webp";

import './MaldivesResortsSlider.scss';
import SpeakToExpertButton from "src/components/home/SpeakToExpertButton";

const resorts = [
  { img: place8, label: "JOALI Being" },
  { img: place1, label: "Velaa Private Island Maldives" },
  { img: place4, label: "Soneva Fushi" },
  { img: place12, label: "Soneva Jani" },
  { img: place2, label: "The Nautilus" },
  { img: place10, label: "JOALI Maldives" },
  { img: place7, label: "Waldorf Astoria Maldives Ithaafushi" },
  { img: place6, label: "One&Only Reethi Rah" },
  { img: place9, label: "Milaidhoo Maldives" },
  { img: place3, label: "Kudadoo Maldives Private Island" },
  { img: place11, label: "Gili Lankanfushi Maldives" },
  { img: place5, label: "Finolhu, A Seaside Collection Resort, a Member of Design Hotels" },
];

const MaldivesResortsSlider = () => {
  const { t, i18n } = useTranslation('maldives');
  const { t: tCommon } = useTranslation('common');
  const isRu = i18n.language === 'ru';

  return (
    <div className="maldives_resorts lg:!py-[60px] sm:!py-10 !py-8">
      <div className="px-5 sm:px-6">
        <h2 className="section-heading text-center mb-[10px]">
          <Trans
            i18nKey="resorts.heading"
            ns="maldives"
            components={{ br1: <br className="sm:hidden" /> }}
          />
        </h2>

        <p className={`maldives_resorts_subtitle mx-auto leading-[20px] sm:leading-[29px] ${isRu ? 'max-w-[488.25px] lg:max-w-[890px]' : 'max-w-[488.25px] lg:max-w-[750px]'}`}>
          {t('resorts.subtitle')}
        </p>
      </div>

      <div className="min-h-[50vw] sm:min-h-[312px] lg:min-h-[462px]">
        <Swiper
          modules={[Pagination]}
          loop={true}
          slidesPerView={"auto"}
          centeredSlides={true}
          slideToClickedSlide={true}
          spaceBetween={13}
          pagination={{ clickable: true, el: ".maldives_resorts_pagination" }}
          speed={300}
          touchEventsTarget="container"
          breakpoints={{
            640: { spaceBetween: 26 },
            1100: { spaceBetween: 40 }
          }}
          className="maldives_resorts_slider"
        >
          {resorts.map((resort, index) => (
            <SwiperSlide key={index}>
              <div className="maldives_resorts_item">
                <div className="maldives_resorts_item__img">
                  <img src={resort.img} alt={resort.label} />
                </div>
                <div className="maldives_resorts_item__label capitalize">
                  <span>{resort.label}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <p className="maldives_resorts_bottom_text mx-auto sm:max-w-full leading-[20px] sm:leading-[29px]">
        <Trans
          i18nKey="resorts.footerNote"
          ns="maldives"
          components={{ br1: <br className="lg:block hidden" /> }}
        />
      </p>
      <div className="pagination maldives_resorts_pagination"></div>
      <div className="flex justify-center">
        <SpeakToExpertButton text={tCommon('cta.planMaldivesEscape')} />
      </div>
    </div>
  );
};

export default MaldivesResortsSlider;
